module.exports = __webpack_public_path__ + "static/media/collage.03769370.jpg";